const webhookEventTypes = [{ id: 0, name: "mandate-onboarding" }];
export default webhookEventTypes;
